var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"86px"}},[_c('div',{staticClass:"news-detail-content",domProps:{"innerHTML":_vm._s(_vm.newsContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }